import React, { useState, useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  Input,
  Label,
  FormGroup,
} from "reactstrap";
import moment from "moment";
import * as Icons from "react-feather";
import { urlAPI, getUser, getToken } from "utility/Common";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import Axios from "axios";
import { useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import { Tab } from "bootstrap";

const headerStyle = {
  fontSize: "16px",
  color: "black",
  margin: "5px 5px 5px 5px",
};
const bodyStyle = {
  fontSize: "14px",
  color: "black",
  margin: "1px 1px 1px 1px",
};
const containerStyle = {
  padding: "1cm 1cm 1cm 1cm",
};
// const borderStyle = {
//   border: "2px solid black",
// };
// const borderTopNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "none solid solid solid",
// };
// const borderBottomNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "solid solid none solid",
// };
// const borderTopBottomNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "none solid none solid",
// };


const JABATAN_TTD_OPTIONS = [
  { value: "DIREKSI", label: "DIREKSI" },
  { value: "MANAJER", label: "MANAJER" },
];

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const data = this.props.dataPrint;
    const jabatanTTD = this.props.jabatanTTD || "DIREKSI";

    console.log("dataPrint", data);
    return (
      <div style={containerStyle}>
        <div style={{ height: "4.5cm" }} />
        <Table borderless={true}>
          <tbody>
            <tr>
              <td style={{ width: "60%", verticalAlign: "top" }}>
                <div style={{ height: "32px" }} />
              </td>
              <td
                style={{
                  width: "40%",
                  paddingLeft: "0",
                  paddingTop: "0.5cm",
                  verticalAlign: "top",
                }}
              >
                <p style={headerStyle}>
                  {data?.NOBA}/{moment(data?.TANGGALBA).format("MM")}
                  /PR.02.04/BA/PGM/
                  {moment(data?.TANGGALBA).format("YYYY")}
                </p>
                <p style={headerStyle}>
                  {moment(data?.TANGGALBA).format("DD MMMM YYYY")}
                </p>
              </td>
            </tr>
            <tr
              style={{
                height: "8.5cm",
              }}
            >
              <td
                style={{
                  width: "60%",
                  paddingLeft: "4cm",
                  paddingTop: "2.5cm",
                  verticalAlign: "top",
                }}
              >
                <p style={bodyStyle}>PT PETRO GRAHA MEDIKA</p>
                <br />
                <p style={bodyStyle}>{data?.URAIAN}</p>
              </td>
              <td
                style={{
                  width: "40%",
                  paddingLeft: "5cm",
                  paddingTop: "2.5cm",
                  verticalAlign: "top",
                }}
              >
                <p style={bodyStyle}>{data?.KODEANGG}</p>
              </td>
            </tr>
          </tbody>
        </Table>
        <Table borderless={true}>
          <tbody>
            <tr
              style={{
                height: "1cm",
              }}
            >
              <td
                style={{
                  width: "70%",
                  paddingLeft: "9cm",
                  verticalAlign: "top",
                }}
              >
                <p style={bodyStyle}>
                  {data?.JENIS === "ORDER KERJA" ? data?.NO1 : " "}
                </p>
              </td>
              <td
                style={{
                  width: "30%",
                  paddingLeft: "4cm",
                  verticalAlign: "top",
                }}
              >
                <p style={bodyStyle}>
                  {data?.JENIS === "ORDER KERJA" &&
                  data?.TANGGAL1 !== "" &&
                  data?.TANGGAL1 !== null
                    ? moment(data?.TANGGAL1).format("DD/MM/YYYY")
                    : " "}
                </p>
              </td>
            </tr>
            <tr
              style={{
                height: "1cm",
              }}
            >
              <td
                style={{
                  width: "70%",
                  paddingLeft: "9cm",
                  verticalAlign: "top",
                }}
              >
                <p style={bodyStyle}>
                  {data?.JENIS === "KONTRAK" ? data?.NO1 : " "}
                </p>
              </td>
              <td
                style={{
                  width: "30%",
                  verticalAlign: "top",
                  paddingLeft: "4cm",
                }}
              >
                <p style={bodyStyle}>
                  {data?.JENIS === "KONTRAK" &&
                  data?.TANGGAL1 !== "" &&
                  data?.TANGGAL1 !== null
                    ? moment(data?.TANGGAL1).format("DD/MM/YYYY")
                    : " "}
                </p>
              </td>
            </tr>
            <tr
              style={{
                height: "2.2cm",
              }}
            >
              <td
                style={{
                  width: "70%",
                  paddingLeft: "10cm",
                  verticalAlign: "top",
                }}
              >
                <p style={bodyStyle}>
                  {data?.JENIS === "ADDENDUM" ? data?.NO1 : " "}
                </p>
                <p style={bodyStyle}>
                  {data?.JENIS === "ADDENDUM" ? data?.NO2 : " "}
                </p>
                <p style={bodyStyle}>
                  {data?.JENIS === "ADDENDUM" ? data?.NO3 : " "}
                </p>
              </td>
              <td
                style={{
                  width: "30%",
                  verticalAlign: "top",
                  paddingLeft: "4cm",
                }}
              >
                <p style={bodyStyle}>
                  {data?.JENIS === "ADDENDUM" &&
                  data?.TANGGAL1 !== "" &&
                  data?.TANGGAL1 !== null
                    ? moment(data?.TANGGAL1).format("DD/MM/YYYY")
                    : " "}
                </p>
                <p style={bodyStyle}>
                  {data?.JENIS === "ADDENDUM" &&
                  data?.TANGGAL2 !== "" &&
                  data?.TANGGAL2 !== null
                    ? moment(data?.TANGGAL2).format("DD/MM/YYYY")
                    : " "}
                </p>
                <p style={bodyStyle}>
                  {data?.JENIS === "ADDENDUM" &&
                  data?.TANGGAL3 !== "" &&
                  data?.TANGGAL3 !== null
                    ? moment(data?.TANGGAL3).format("DD/MM/YYYY")
                    : " "}
                </p>
              </td>
            </tr>
            <tr
              style={{
                height: "1cm",
              }}
            >
              <td
                style={{
                  width: "70%",
                  paddingLeft: "9cm",
                  verticalAlign: "top",
                }}
              >
                <p style={bodyStyle}>{data?.NOSPW}</p>
              </td>
              <td
                style={{
                  width: "30%",
                  verticalAlign: "top",
                  paddingLeft: "4cm",
                }}
              >
                <p style={bodyStyle}>
                  {data?.TANGGALSPW !== "" && data?.TANGGALSPW !== null
                    ? moment(data?.TANGGALSPW).format("DD/MM/YYYY")
                    : " "}
                </p>
              </td>
            </tr>
            <tr
              style={{
                height: "1cm",
              }}
            >
              <td
                style={{
                  width: "70%",
                  paddingLeft: "7.5cm",
                  paddingTop: "0.8cm",
                  verticalAlign: "top",
                }}
              >
                <p style={bodyStyle}>
                  <strong>{data?.NAMAREKANAN}</strong>
                </p>
                <p style={bodyStyle}>{data?.ALAMATREKANAN}</p>
                <p style={bodyStyle}>{data?.KOTAREKANAN}</p>
              </td>
              <td style={{ width: "30%", verticalAlign: "top" }}>
                <p style={bodyStyle}> </p>
              </td>
            </tr>
          </tbody>
        </Table>
        <Table borderless={true}>
          <tbody>
            <tr
              style={{
                height: "2cm",
                paddingTop: "0.5cm",
              }}
            >
              <td
                style={{
                  paddingLeft: "55%",
                  verticalAlign: "top",
                }}
                colSpan={2}
              >
                <p style={bodyStyle}>
                  {data?.TGLSERAH !== "" && data?.TGLSERAH !== null
                    ? moment(data?.TGLSERAH).format("DD/MM/YYYY")
                    : " "}
                </p>
              </td>
            </tr>
            <tr
              style={{
                height: "1cm",
              }}
            >
              <td
                colSpan={2}
                style={{
                  paddingLeft: "40%",
                  verticalAlign: "top",
                }}
              >
                <p style={bodyStyle}>
                  {/*data?.TGLHRSSERAH !== "" && data?.TGLHRSSERAH !== null
                    ? moment(data?.TGLHRSSERAH).format("DD/MM/YYYY")
                    : " "*/}
                </p>
              </td>
            </tr>
            <tr
              style={{
                height: "1cm",
              }}
            >
              <td
                style={{
                  width: "20%",
                  maxWidth: "20%",
                  paddingLeft: "2.5cm",
                  verticalAlign: "top",
                }}
              >
                <p style={bodyStyle}>{/*data?.TERLAMBAT*/}</p>
              </td>
              <td
                style={{
                  width: "80%",
                  maxWidth: "80%",
                  paddingLeft: "6cm",
                  verticalAlign: "top",
                  textAlign: "left",
                }}
              >
                {Number(/*data?.DENDA !== 0*/) ? (
                  <p style={bodyStyle}>
                    {"Rp. "}
                    <NumberFormat
                      value={Number(data?.DENDA)}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </p>
                ) : (
                  <p style={bodyStyle}>{/*"0"*/}</p>
                )}
              </td>
            </tr>
            <tr
              style={{
                height: "1cm",
              }}
            >
              <td
                style={{
                  paddingLeft: "5cm",
                  verticalAlign: "top",
                }}
                colSpan={2}
              >
                <p style={bodyStyle}>{/*data?.PERSENTASE}%*/}</p>
              </td>
            </tr>
            <tr
              style={{
                height: "1cm",
              }}
            >
              <td
                style={{
                  paddingLeft: "15%",
                  paddingTop: "0.9cm",
                  verticalAlign: "top",
                }}
                colSpan={2}
              >
                <p style={bodyStyle}>
                  <strong>
                    Rp{" "}
                    <NumberFormat
                      value={Number(data?.NILAI)}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </strong>{" "}
                  {Number(data?.PPN) === 1 && "belum termasuk PPN"}
                </p>
                <p style={bodyStyle}>({data?.TERBILANG} rupiah)</p>
              </td>
            </tr>
          </tbody>
        </Table>
        <p
          style={{
            fontSize: "18px",
            color: "black",
            margin: "1px 1px 1px 1px",
            paddingTop: "5cm",
            paddingLeft: "13cm",
          }}
        >
          {jabatanTTD}
        </p>
      </div>
    );
  }
}

export default function PrintComponent(props) {
  const { handleClose, open, noba } = props;
  const componentRef = useRef();
  const dispatch = useDispatch();
  const [dataPrint, setDataPrint] = useState(null);
  const [loading, setLoading] = useState(false);
  const [jabatanTTD, setJabatanTTD] = useState("DIREKSI");

  useEffect(() => {
    if (open) {
      fetchData();
      setJabatanTTD("DIREKSI");
    }
  }, [open]);

  const fetchData = () => {
    Axios.get(urlAPI + "/v1/inventory/printBAJasa?noba=" + noba, {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
      .then((response) => {
        setDataPrint({
          rows: response?.data?.result?.rows,
        });
        setLoading(false);
        // console.log(response?.data?.result?.rows[0]?.DAFTARBARANG[0]?.);
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoading(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoading(false);
        }
      });
  };

  const printStyle = `
 @media all {
  .page-break {
    display: none;
  }
}

@media print {
  html, body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
  }
}

@media print {
  .page-break {
    margin-top: 1rem;
    display: block;
    page-break-before: auto;
  }
}

@page {
  size: auto;
  margin: 20mm;
}
  `;
  console.log("dataPrint out", dataPrint);
  return (
    <Modal
      isOpen={open}
      toggle={handleClose}
      className="modal-dialog-centered modal-xl"
      backdrop="static"
    >
      <ModalHeader toggle={handleClose}>Print Preview</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="jabatanTTD" style={{ fontWeight: 600 }}>
            Penandatangan
          </Label>
          <Input
            type="select"
            id="jabatanTTD"
            name="jabatanTTD"
            value={jabatanTTD}
            onChange={(e) => setJabatanTTD(e.target.value)}
            disabled={loading}
          >
            {JABATAN_TTD_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Input>
        </FormGroup>

        <ReactToPrint
          trigger={() => (
            <Button
              color="primary"
              // style={{ width: "200px" }}
              block
              disabled={loading}
              // size="sm"
            >
              <Icons.Printer size={14} /> Print
            </Button>
          )}
          content={() => componentRef.current}
          pageStyle={printStyle}
        />
        <hr />
        {loading ? (
          <div className="text-center">
            <h4>Loading...</h4>
          </div>
        ) : (
          <ComponentToPrint
            ref={componentRef}
            dataPrint={dataPrint?.rows[0]}
            jabatanTTD={jabatanTTD}
          />
        )}
      </ModalBody>
    </Modal>
  );
}